var React = require('react');

function IconHeartEmpty (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_1484","data-name":"Path 1484","d":"M411.234,914.771a3.442,3.442,0,0,0-2.649,2.61,3.407,3.407,0,0,0,.617,2.824h-.014l5.671,6.616a.688.688,0,0,0,1.045,0l5.671-6.616h-.014a3.407,3.407,0,0,0,.617-2.824,3.441,3.441,0,0,0-6.8.76A3.445,3.445,0,0,0,411.234,914.771Z","transform":"translate(-407.742 -913.941)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5"}));
}

IconHeartEmpty.defaultProps = {"width":"15.278","height":"13.87","viewBox":"0 0 15.278 13.87"};

module.exports = IconHeartEmpty;

IconHeartEmpty.default = IconHeartEmpty;
